<template>
  <div class="dateField">
    <div class="datePicker">
      <label class="subtitle-2 black--text pl-3">
        {{ field.label }}
        <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
      </label>
      <v-date-picker
        :allowed-dates="allowedDates"
        first-day-of-week="1"
        v-model="dateSelector"
        :min="minDate.toISOString()"
      />
      <div class="errorMsg" v-if="block.errorMessages">{{block.errorMessages[0]}}</div>
      <div class="hint" v-if="field.hint">{{field.hint}}</div>
    </div>

    <div class="timePicker">
      <div v-if="field.config.hour" style="margin-bottom:20px;">
        <label class="subtitle-2 black--text">
          Heure
          <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
        </label>
        <time-selector v-model="hour" />
      </div>
      <div class="result">
        <label class="service-info__title fs-small">{{ field.name }}</label>
        {{ displayedDate }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FieldMixin from "./FieldMixin";
import TimeSelector from "../../input/TimeSelector";

export default {
  components: {
    TimeSelector
  },
  mixins: [FieldMixin],
  name: "FieldDate",
  data: function() {
    return {
      minDate: moment().add(2, "d")
    };
  },
  computed: {
    dateSelector: {
      get: function() {
        return this.date ? this.date.toISOString().substr(0, 10) : moment();
      },
      set: function(date) {
        this.date = date;
      }
    },
    date: {
      get: function() {
        if (typeof this.model == Date) {
          return this.model;
        } else {
          if (this.model) {
            return new Date(this.model);
          } else {
            return moment();
          }
        }
      },
      set: function(date) {
        this.setDate(date, this.hour);
      }
    },
    hour: {
      get: function() {
        return this.model
          ? moment(new Date(this.model)).format("HH:mm")
          : "09:00";
      },
      set: function(heure) {
        this.setHour(heure);
      }
    },

    displayedDate: function() {
      let d = moment(new Date(this.date));
      return this.field.config.hour
        ? d.format("DD/MM/YYYY HH:mm")
        : d.format("DD/MM/YYYY");
    }
  },

  methods: {
    allowedDates: val => ![0, 6].includes(new Date(val).getDay()),
    initialize: function() {
      this.date = this.model ? new Date(this.model) : new Date();
      this.heure = this.model
        ? new Date(this.model).getHours()
        : moment().hours();
      this.minutes = this.model
        ? new Date(this.model).getMinutes()
        : parseInt(moment().minutes() / 5) * 5;
    },
    validate: function() {
      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");

      } else {
        this.isValid = true;
      }
    },
    setDate(date, hour) {
      let d = new Date(date);
      if (this.field.config && this.field.config.hour) {
        let h = hour.split(":")[0];
        let m = hour.split(":")[1];
        d.setHours(h, m);
      }
      this.model = d;
      this.update();
    },
    setHour(hour) {
      this.setDate(this.date, hour);
    }
  }
};
</script>

<style lang="less">
.dateField {
  display: flex;
  .datePicker {
    label {
      display: block;
    }
  }
  .timePicker {
    margin-left: 20px;
    &.readonly {
      margin-left: 0;
    }
    .v-clock-container {
      display: flex;
      .v-clock {
        display: flex;
        flex-direction: column;
        span {
          font-size: 27px;
          text-align: center;
          padding-right: 14px;
        }
        input {
          font-size: 27px;
          font-weight: bold;
          text-align: center;
          border: none;
        }
      }
    }
  }
}
</style>
